import React from 'react';
import { SubscriptionOverlay } from '../../../components/SubscriptionOverlay';
import formatDate from '../../manageSubscriptions/utils/formatDate';

export const UpcomingSubscriptionOverlay = ({
  dismiss,
  renewalDate,
  brandName,
  brandCode,
  ageGroup,
}: {
  dismiss: () => void;
  brandName: string;
  brandCode: string;
  ageGroup: string;
  renewalDate: string;
}) => {
  return (
    <SubscriptionOverlay
      title="Upcoming Subscription"
      heading="Your access to this curriculum will begin with your upcoming subscription"
      subscriptions={[
        {
          name: brandName,
          subtitle: ageGroup,
          brandCode,
          additionalDetail: `Begins ${formatDate(renewalDate)}`,
        },
      ]}
      instructions={[]}
      dismissHandler={dismiss}
    />
  );
};
